var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "ai-answer-button-wrapper"
  }, [_c("div", {
    staticClass: "button-item",
    on: {
      click: _vm.copyHandler
    }
  }, [_c("svg-icon", {
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      name: "copy"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("复制")])], 1), _c("div", {
    staticClass: "button-item",
    style: {
      color: _vm.answer.evaluate === 10 ? "#3B72FF" : "#000"
    },
    on: {
      click: function click($event) {
        return _vm.evaluateHandler(_vm.answer, 10);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "good-job"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("点赞")])], 1), _c("div", {
    staticClass: "button-item",
    style: {
      color: _vm.answer.evaluate === 1 ? "#3B72FF" : "#000"
    },
    on: {
      click: function click($event) {
        return _vm.collectInfo(_vm.answer, 1);
      }
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "bad-job"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("点踩")])], 1), _c("div", {
    staticClass: "button-item",
    on: {
      click: _vm.reloadHandler
    }
  }, [_c("svg-icon", {
    attrs: {
      name: "van-icon-replay"
    }
  }), _c("div", {
    staticClass: "text"
  }, [_vm._v("重新生成")])], 1), _c("collect-bad-info", {
    ref: "collectRef",
    on: {
      submit: _vm.feedback
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };